/**
 * Mixpanel分析で使用する定数定義
 */

/**
 * Mixpanel分析で使用する機能カテゴリ
 * 新機能追加時は適切なカテゴリを追加してください
 */
export const Feature = {
  Chat: 'chat',
  Invitation: 'invitation',
  PartnerCompany: 'partner_company',
  Document: 'document',
  QuoteRequest: 'quote_request',
  Booking: 'booking',
  Account: 'account',
  Auth: 'auth',
  Team: 'team',
  Password: 'password',
  Forwarder: 'forwarder',
  Guest: 'guest',
  Shipment: 'shipment',
  PreRegistration: 'pre_registration',
  Invoice: 'invoice',
  Quote: 'quote',
  // Admin専用機能
  Container: 'container',
  AirTransportCargo: 'air_transport_cargo',
  ArrivalNotices: 'arrival_notices',
  BookingNote: 'booking_note',
  CustomsClearance: 'customs_clearance',
  Delivery: 'delivery',
  TransportRequest: 'transport_request',
  PortrichBillOfLadings: 'portrich_bill_of_ladings',
  ShippingInstructions: 'shipping_instructions',
  DebitCreditNote: 'debit_credit_note',
  ProfitShare: 'profit_share',
  Task: 'task',
  Progress: 'progress',
} as const

/**
 * Mixpanel分析で使用するアクション種別
 * ユーザーの操作や状態変化を表します
 */
export const Action = {
  Create: 'create',
  Update: 'update',
  Upsert: 'upsert',
  Click: 'click',
} as const

/**
 * Mixpanel分析で使用する標準イベント名
 * 統一されたイベント命名により、分析の一貫性を保ちます
 */
export const EventName = {
  UserLogin: 'User Login',
  UserLogout: 'User Logout',
  PageViewed: 'Page Viewed',
  DialogOpened: 'Dialog Opened',
  DialogClosed: 'Dialog Closed',
  FormSubmitted: 'Form Submitted',
  FormValidationError: 'Form Validation Error',
  ButtonClicked: 'Button Clicked',
} as const
